"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTotalValueConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcTotalValueConstants = (function () {
    function BcTotalValueConstants() {
    }
    BcTotalValueConstants.TOTAL_VALUE_CONTAINER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-total-value-container");
    BcTotalValueConstants.TOTAL_VALUE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-total-value");
    BcTotalValueConstants.TOTAL_VALUE_ELLIPSIS_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-total-value-ellipsis");
    BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-total-value-cell-information");
    BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_PRIMARY_CLASS = "".concat(BcTotalValueConstants.TOTAL_VALUE_CELL_INFORMATION_CLASS, "-primary");
    BcTotalValueConstants.TOTAL_VALUE_CELL_COMPLEMENTARY_PRIMARY_CLASS = "".concat(BcTotalValueConstants.TOTAL_VALUE, "-cell-complementary-primary");
    BcTotalValueConstants.TOTAL_VALUE_BREAKPOINT_XS = 576;
    BcTotalValueConstants.TOTAL_VALUE_BREAKPOINT_MD = 768;
    BcTotalValueConstants.TOTAL_VALUE_NUMBER_COLUMNS_MOBILE = 2;
    BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_INFORMATION_COLUMNS = 4;
    BcTotalValueConstants.TOTAL_VALUE_MAX_NUMBER_COMPLEMENTARY_COLUMNS = 1;
    return BcTotalValueConstants;
}());
exports.BcTotalValueConstants = BcTotalValueConstants;
